import React from 'react'
import { ReactTable } from '@softura/fluentui-reacttable'
import './Grid.scss'

interface IProps {
  className?: string,
  data?: any,
  columns?:any,
  sort?:boolean,
  defaultPageSize?: number,
  pageSizes?:any,
  globalSearch?: boolean
  selection?: string,
  pagination?: boolean,
  filter?:boolean,
  filteringMode?:any,
  getFilterValue?:any,
  serverTotal?:any,
  fetchAction?:any
  pagesCount?: any
  isServerSide?: any
  defaultPaginationPosition?:any,
  fixedHeader?:any,
  editable?:any,
  getUpdatedValue?:any,
  customAddRow?:any,
  customDelete?:any,
  validation?:any,
  loading?: boolean,
  pageIndex?: number,
  'data-attribute'?: any,
}
const GridContainer = ({
  className,
  data,
  columns,
  sort,
  defaultPageSize,
  pageSizes,
  globalSearch,
  selection,
  pagination,
  filter,
  filteringMode,
  getFilterValue,
  serverTotal,
  fetchAction,
  pagesCount,
  isServerSide,
  defaultPaginationPosition,
  fixedHeader,
  editable,
  getUpdatedValue,
  customAddRow,
  customDelete,
  validation,
  loading,
  pageIndex,
  'data-attribute': dataAttribute
}:IProps) => {
  return (
    <ReactTable
      className = {`${className}`}
      globalSearch = {globalSearch}
      pageSizes = {pageSizes}
      defaultPageSize = {defaultPageSize}
      sort = {sort}
      columns = {columns}
      data = {data}
      selection = {selection}
      pagination={pagination}
      filter={filter}
      filteringMode={filteringMode}
      getFilterValue={getFilterValue}
      serverTotal={serverTotal}
      fetchAction={fetchAction}
      pagesCount={pagesCount}
      isServerSide={isServerSide}
      defaultPaginationPosition={defaultPaginationPosition}
      fixedHeader={fixedHeader}
      editable={editable}
      getUpdatedValue={getUpdatedValue}
      customAddRow={customAddRow}
      customDelete={customDelete}
      validation={validation}
      loading={loading}
      pageIndex={pageIndex}
      data-attribute={dataAttribute}
    />
  )
}

export default GridContainer
